var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticStyle:{},attrs:{"id":"application"}},[_c('v-responsive',{staticClass:"d-flex align-start",style:(_vm.styles),attrs:{"min-height":"100vh"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }